import { GenericModel } from '../shared/model/generic.model';

export class Onboarding extends GenericModel {

	public token: string;

}
